<script setup>
    import { computed, ref } from "vue";
    import { usePage, useForm } from "@inertiajs/vue3";
    import Modal from "../InertiaComponents/Modal.vue";
    import InputLabel from "../InertiaComponents/InputLabel.vue";
    import TextInput from "../InertiaComponents/TextInput.vue";
    import InputError from "../InertiaComponents/InputError.vue";
    import PrimaryButton from "../InertiaComponents/PrimaryButton.vue";

    const page = usePage();

    const show = computed(() => page.props.auth?.logged_in && page.props.auth?.user?.profile_complete === false);

    const form = useForm({
        _method: "PUT",
        first_name: page.props.auth?.user?.first_name ?? "",
        last_name: page.props.auth?.user?.last_name ?? "",
        display_name: page.props.auth?.user?.display_name ?? "",
        name: page.props.auth?.user?.name ?? "",
        email: page.props.auth?.user?.email ?? "",
    });

    const submit = () => {
        form.post(route("user-profile-information.update"), {
            errorBag: "updateProfileInformation",
            preserveScroll: true,
        });
    };
</script>

<template>
    <Modal :show="show" :closeable="false" max-width="md">
        <div class="p-6">
            <h2 class="text-lg font-semibold text-gray-900 mb-1">Complete Your Profile</h2>
            <p class="text-sm text-gray-600 mb-6">Please fill in your details to continue.</p>

            <form @submit.prevent="submit" class="space-y-4">
                <div>
                    <InputLabel for="cp_first_name" value="First Name" />
                    <TextInput
                        id="cp_first_name"
                        v-model="form.first_name"
                        type="text"
                        class="mt-1 block w-full"
                        required
                        autocomplete="given-name"
                        autofocus
                    />
                    <InputError :message="form.errors.first_name" class="mt-2" />
                </div>

                <div>
                    <InputLabel for="cp_last_name" value="Last Name" />
                    <TextInput
                        id="cp_last_name"
                        v-model="form.last_name"
                        type="text"
                        class="mt-1 block w-full"
                        required
                        autocomplete="family-name"
                    />
                    <InputError :message="form.errors.last_name" class="mt-2" />
                </div>

                <div>
                    <InputLabel for="cp_display_name" value="Display Name" />
                    <p class="text-xs text-gray-500 mt-0.5">This is the name others will see (e.g. a username or nickname).</p>
                    <TextInput
                        id="cp_display_name"
                        v-model="form.display_name"
                        type="text"
                        class="mt-1 block w-full"
                        required
                        autocomplete="nickname"
                    />
                    <InputError :message="form.errors.display_name" class="mt-2" />
                </div>

                <div class="flex justify-end pt-2">
                    <PrimaryButton :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                        Save &amp; Continue
                    </PrimaryButton>
                </div>
            </form>
        </div>
    </Modal>
</template>
